module.exports = __webpack_public_path__ + "media/registration/meetups@3x-b05ba0e6.png";